import { AMPLITUDE_API_KEY } from '@Src/BuildConstants';
import * as amplitude from '@amplitude/analytics-browser';

export const initializeAmplitude = (): void => {
  amplitude?.init(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    defaultTracking: true,
  });
  optInAmplitude();
};

export const optInAmplitude = (): void => {
  amplitude?.setOptOut(false);
};

export const optOutAmplitude = (): void => {
  amplitude?.setOptOut(true);
};

export const useTracking = (): {
  trackEvent: (eventName: string, options?: Record<string, string>) => void;
} => {
  const trackEvent = (
    eventName: string,
    options?: Record<string, string>,
  ): void => {
    if (options) {
      amplitude?.track(eventName, options);
    } else {
      amplitude?.track(eventName);
    }
  };

  return {
    trackEvent,
  };
};
